import { client as apiSuiteClient } from '../openapi-clients-generated/suite/client.gen';
import { configureZynoOpenApiClient } from './helpers';

export function configurePublicApiClient() {
    apiSuiteClient.setConfig({
        baseUrl: import.meta.env.VITE_APP_SUITE_API_URL
    });
    configureZynoOpenApiClient('public', apiSuiteClient);
}
